import React, { useState, useEffect } from 'react';
import { TreeviewDropdown } from '../../../CommonComponent';
import { IPartDropDownProps } from './maintenancerecommendationinterface';
import machineservice from '../../../../../../ClientApp/src/services/machineservice';
import { RESOURCE } from '../../../../const/resource';
import { useTranslation } from 'react-i18next';

const PartDropDownList = (props: IPartDropDownProps) => {
    
    const { t } = useTranslation();
    const [, setIsLoading] = useState<boolean>(false);
    const [partOptions, setPartOptions] = useState<any>([]);
    useEffect(() => {
        setIsLoading(true);
        machineservice.getRecommendationPartNoOptions(props.model, props.recommendationParts).then((response: any) => {
            setIsLoading(false);
            setPartOptions(response.result?.map((t: any) => ({ title: t.partNumber, value: t.childPartNumber, quantity: t.quantity })) ?? []);
        });
    }, [])

    const onValueChange = (event: any) => {
        props.onChange(partOptions?.find((s: any) => s.value == event));
    }
    
    return (
        <TreeviewDropdown value={props?.partNo} className="part-ddl-list" treeData={partOptions} onChange={onValueChange} placeholder={t(RESOURCE.MyK_Select)} showSearch={true} />
    )
}

export default PartDropDownList